import { Controller } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/palette/fill-color-palette/config';

@Controller({
    menuItems: MENU_CONFIGS,
})
export class FillColorPaletteController {
}
